import { lazy } from 'react';

/** Загружает список тиражей промокодов */
export const PromoCodePrintingsPageAsync = lazy(() => import('./PromoCodePrintingsPage'));
